export default __webpack_public_path__ + "static/media/justice-grp.579efdae.png";